import { useConciergeProducts } from '@apps/card/concierge/useConciergeProducts';
import { useGalleryPlacementSeed } from './useGalleryPlacementSeed';

/**
 * The gallery's concierge products, in the order its tiles show them. Seeded with the gallery's
 * placement seed (PRNT-5494), so the server and the client, and every caller, see one order.
 */
export const useGalleryConciergeProducts = () => useConciergeProducts(useGalleryPlacementSeed());
